module.exports = __webpack_public_path__ + "static/media/Sunflower-Village-Articles-of-Incorporation-1.cf324568.pdf";